import { CustomerSpecialRequirement } from "./enquiry.model";

export class CreateEnquiryCustomer {
    customerName?: string;
    customerCountryId?: number | null;
    unitSystem?: string;
    currency?: string;
}

export class CreateEnquiry {
    salesPersonId?: number;
    salesOfficeId?: number;
    customerId?: number | null;
    customer?: CreateEnquiryCustomer;
    unitSystem?: string;
    currency?: string;
    dueDate?: number | null;
    optionDate?: number | null;
    projectName?: string | null;
    alloySurcharge?: boolean;
    orderReason?: string;
    applicableNorms?: string | null;
    normGradesId?: number[] | null;
    marketingGradeId?: number | null;
    rawMaterialGrade?: string;
    testCategory?: string | null;
    od?: number | null;
    odUom?: string | null;
    wt?: number | null;
    wtUom?: string | null;
    id?: number | null;
    idUom?: string | null;
    npsScheduleId?: number | null;
    smsId?: number;
    totalWeight?: number;
    totalWeightUom?: string;
    remark?: string | null;
    marketFamilyId?: number;
    creationMode?: string;
    sourceEnquiryNo?: string | null;
    customerEnquiryNo?: string;
    mstOfferStatus?: string;
    length?: number;
    lengthUom?: string;
    offerValidityId?: number;
    offerValidityDate?: number | null;
    customerSpecialRequirements?: CustomerSpecialRequirement[];
    customerRequestDate?: number | null;
    keepItdcrResults?: boolean;
    offerSchemeCode?: string | null;
    bonusSchemeCode?: string | null;
}
